import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  showPreview() {
    this.previewTarget.innerHTML = ""

    const files = this.inputTarget.files
    if (!files.length) return

    for (const file of files) {
      const reader = new FileReader()

      reader.onload = e => {
        const container = document.createElement("div")
        container.classList.add(
          "d-inline-flex",
          "flex-column",
          "align-items-center",
          "justify-content-center",
          "m-1",
          "text-center",
          "border",
          "rounded"
        )
        container.style.width = "140px"
        container.style.height = "140px"
        container.style.overflow = "hidden"
        container.style.verticalAlign = "middle"
        container.style.lineHeight = "1"

        let content

        // Image
        if (file.type.startsWith("image/")) {
          content = document.createElement("div")
          content.classList.add(
            "d-flex",
            "align-items-center",
            "justify-content-center",
            "w-100",
            "h-100"
          )

          const img = document.createElement("img")
          img.src = e.target.result
          img.style.maxWidth = "100%"
          img.style.maxHeight = "100%"
          img.style.objectFit = "contain"
          content.appendChild(img)
        }

        // PDF
        else if (file.type === "application/pdf") {
          content = this._iconBox("bi-file-earmark-pdf", "text-danger", file.name)
        }

        // Other files
        else {
          content = this._iconBox("bi-file-earmark", "text-secondary", file.name)
        }

        container.appendChild(content)
        this.previewTarget.appendChild(container)
      }

      reader.readAsDataURL(file)
    }
  }

  _iconBox(iconClass, colorClass, fileName) {
    const wrapper = document.createElement("div")
    wrapper.classList.add(
      "d-flex",
      "flex-column",
      "align-items-center",
      "justify-content-center",
      "h-100",
      "w-100"
    )

    // Prevent font icons from shifting vertically
    wrapper.style.lineHeight = "1"
    wrapper.style.margin = "0"
    wrapper.style.padding = "0"

    const icon = document.createElement("i")
    icon.classList.add("bi", iconClass, "fs-1", colorClass)
    icon.style.display = "block"
    icon.style.lineHeight = "1"
    icon.style.marginBottom = "0.25rem"

    const label = document.createElement("div")
    label.textContent = fileName
    label.classList.add("small", "text-truncate", "w-100")

    wrapper.appendChild(icon)
    wrapper.appendChild(label)

    return wrapper
  }
}
